import { keepPreviousData } from '@tanstack/react-query';

import { Company } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { companyId } from '/constants';

export const companyTags: unknown[] = ['company', 'service'];

export const useCompanyRetrieve = (
  id = companyId,
  options?: IUseQueryOptionsExtended<Company | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery<GenericFailure | Error, Company>(
    companyTags.concat(id),
    () => {
      return services2.companyService.retrieve(id);
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );

  return {
    ...res,
    data: res.data,
  };
};
